import { CanActivate, Router } from '@angular/router';
import { AutheticationService } from './shared/index';
import { Injectable } from '@angular/core';

@Injectable()
export class AutheticationGuard implements CanActivate {

  constructor ( private auth: AutheticationService, private router: Router ) {}

  canActivate () {
    if ( this.auth.isToken() ) {
      return true;
    } else {
      this.router.navigate( ['/login'] );
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/authetication.guard.ts